import cx from 'classnames'
import { FC } from 'react'
import { motionSlide } from 'src/hooks/useAppear'

import { AccordionProps } from '../Accordion'
import { BlockTitleProps } from '../BlockTitle'

import * as SC from './styled'

export type AccordionListProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  accordions?: AccordionProps[]
}

const AccordionList: FC<AccordionListProps> = ({
  className,
  blockTitleProps,
  accordions,
}) => {
  const { motionProps } = motionSlide({})

  return (
    <SC.Container className={cx('AccordionList', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      <SC.Accordions {...motionProps}>
        {accordions?.map((accordion, index) => (
          <SC._Accordion key={index} {...accordion} />
        ))}
      </SC.Accordions>
    </SC.Container>
  )
}

export default AccordionList
